import * as yup from "yup";
import {
  nameValidator,
  notRequiredDescriptionValidator,
} from "./commonValidators";

export const addFeatureGroupValidator = yup.object({
  name: nameValidator,
  description: notRequiredDescriptionValidator,
});
